import { getFunnelTypeForAnalytics } from "@/utils/analyticsFunnelType";
import { getIsFunnelApplovin } from "@/utils/applovinFunnelUtils";
import { defaultGender } from "@/utils/GenderProvider";
import { IOSVersionDetector } from "@/utils/IOSVersionDetector";
import { localStorageManager, LocalStorageManagerKeys } from "@/utils/localStorageManager";
import { AmplitudeTracker, PaltaDataPlatformTracker } from "@/utils/trackers";
import { EventProps } from "@/utils/trackers/amplidute";

export const logAnalyticsEvent = (evt: string, evtProps?: EventProps) => {
    if (evtProps) {
        AmplitudeTracker.track(evt, evtProps);
        PaltaDataPlatformTracker.track(evt, evtProps);
    } else {
        AmplitudeTracker.track(evt);
        PaltaDataPlatformTracker.track(evt);
    }
};

/**
 * Flush analytics events to the server. Use before navigation (e.g. window.open with _self) so events are sent before the page unloads.
 */
export const flushAnalytics = (): Promise<void[]> => {
    const amplitudeFlush = AmplitudeTracker.flush();
    // Palta uses legacy SDK without flush; allow time for batched send
    const paltaDelay = new Promise<void>((resolve) => setTimeout(resolve, 250));
    return Promise.all([amplitudeFlush, paltaDelay]);
};

/**
 * Unlock analytics queue
 * @param flushQueue - if true, flushes queued events immediately; if false, only unlocks without flushing
 */
export const unlockAnalyticsQueue = (flushQueue = true) => {
    AmplitudeTracker.unlockQueue(flushQueue);
    PaltaDataPlatformTracker.unlockQueue(flushQueue);
};

export const logSingleSourceAnalyticsEvent = (evt: string, evtProps?: EventProps) => {
    AmplitudeTracker.track(evt, evtProps);
};

export const logPaltaAnalyticsEvent = (evt: string, evtProps: EventProps) => {
    PaltaDataPlatformTracker.track(evt, evtProps);
};

export const setAnalyticsUserProperties = (props: EventProps) => {
    AmplitudeTracker.setAmplitudeProperties(props);
    PaltaDataPlatformTracker.setAmplitudeProperties(props);
};

export const setSingleSourceAnalyticsUserProperties = (props: EventProps) => {
    AmplitudeTracker.setAmplitudeProperties(props);
};

export const setPaltaAnalyticsUserProperties = (props: EventProps) => {
    PaltaDataPlatformTracker.setAmplitudeProperties(props);
};
export const setUserId = () => {
    const storedUserId = localStorageManager.getStoredItem<string>(
        LocalStorageManagerKeys.USER_UUID
    );
    if (storedUserId) {
        AmplitudeTracker.setUserId(storedUserId);
        PaltaDataPlatformTracker.setUserId(storedUserId);
    }
};

const setDefaultUserProperties = (isPalta?: boolean) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    let properties: EventProps = {
        ...params,
        web_version: process.env.npm_package_version,
    };

    if (!window.location.pathname.includes("both")) {
        properties = {
            ...properties,
            web_domain: window.location.hostname,
            web_funnel_flow: getFunnelTypeForAnalytics(defaultGender),
            web_gender: defaultGender,
            web_ios_version: IOSVersionDetector.getIOSVersion(),
            web_funnel_applovin: getIsFunnelApplovin(),
        };
    }
    setUserId();
    if (isPalta) {
        setPaltaAnalyticsUserProperties(properties);
    } else {
        setSingleSourceAnalyticsUserProperties(properties);
    }
};

setDefaultUserProperties();
setDefaultUserProperties(true);
